import { DocumentsColumnDefinition } from 'hq/components/views/documents/documents-page/table/documents-table.types';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { RawDocumentData } from 'hq/services/documents-service.types';
import { getDocumentNameLocisedKey } from '../../utils';

export const getDocumentTableData = (data: RawDocumentData[]) => {
  const result: DocumentsColumnDefinition[] = data.flatMap((item) => ({
    id: item.id,
    type: item.type,
    documentName: getDocumentNameLocisedKey(item.type),
    createdAt: item.createdAt,
    updatedAt: item.updatedAt,
    status: item.status,
    flexWorkerName: getFullNameWithInfix({
      firstName: item.firstName,
      infix: item.infix,
      lastName: item.lastName,
    }),
    issuer: item.issuer,
    receiver: item.receiver,
    actions: { documentId: item.id },
  }));

  return result;
};
